module.exports = __webpack_public_path__ + "static/media/footer-notifications-active.56b07c75.png";